import React, {useState} from "react";
import AppButton from "../../../../element/button/AppButton";
import StateViewController from "../../../../vc/StateViewController";
import {IRouteProps} from "../../../../../ts/manager/view/ViewInterface";
import {AccountLoginForm} from "../../../../form/account/AccountLoginForm";
import AccountPasswordResetForm from "../../../../form/account/AccountPasswordResetForm";
import AccountRegisterForm from "../../../../form/account/AccountRegisterForm";

const AccountLoginRegisterView = (props:IRouteProps) =>
{
    const [loginState, setLoginState] = useState<string>("login");

    const viewState = StateViewController({
        routeProps: props
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }

    if (loginState === "register")
    {
        return <section key="register" className="content-block">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <AppButton className="btn secondary reduced me-2" onClick={() => setLoginState("login")}>Login</AppButton>
                    </div>
                </div>
            </div>
            <AccountRegisterForm
                routeProps={props}
            />
        </section>
    }

    if (loginState === "password_reset")
    {
        return <section key="password_reset" className="content-block">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <AppButton className="btn secondary reduced me-2" onClick={() => setLoginState("login")}>Login</AppButton>
                    </div>
                </div>
            </div>
            <AccountPasswordResetForm
                routeProps={props}
            />
        </section>
    }

    return <section key="login" className="content-block">
        <div className="container mb-4">
            <div className="row">
                <div className="col-12">
                    <AppButton className="btn secondary reduced me-2" onClick={() => setLoginState("password_reset")}>Reset
                        Password</AppButton>
                    <AppButton className="btn secondary reduced me-2" onClick={() => setLoginState("register")}>Register</AppButton>
                </div>
            </div>
        </div>
        <AccountLoginForm
            routeProps={props}
            setLoginState={setLoginState}
        />
    </section>
}

export default AccountLoginRegisterView;